import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Collapse, { Panel } from "app/components/ui/collapse/Collapse";
import "./MoreDetails.scss";
import { useSelector } from "react-redux";
import { Button } from "app/components/ui/Button/Button";
import classNames from "classnames";

const MoreDetails = ({
	children,
	expanded,
	initialExpanded,
	collapsedLabel,
	expandedLabel,
	expandedIcon,
	collapsedIcon,
	headerPosition = "top",
	onChange,
	"data-testid": dataTestid,
}) => {
	const isPrintMode = useSelector(state => state.print.isPrintMode);
	const [isExpanded, setIsExpanded] = useState(initialExpanded || expanded || false);

	useEffect(() => {
		if (expanded !== undefined) {
			setIsExpanded(expanded);
		}
	}, [expanded]);

	const handleChange = event => {
		if (typeof event.preventDefault === "function") {
			event.preventDefault();
		}
		const nextExpanded = !isExpanded;
		setIsExpanded(nextExpanded);

		if (typeof onChange === "function") {
			onChange(nextExpanded);
		}
	};

	const activeKey = isExpanded || isPrintMode ? "0" : undefined;
	const headerNode = isExpanded || isPrintMode ? expandedLabel : collapsedLabel;
	const hasIcon = expandedIcon || collapsedIcon;

	const topHeaderNode = headerPosition === "top" ? headerNode : false;

	const bottomHeaderNode = headerPosition === "bottom" && (
		<Button variant="borderless" className="rc-collapse-header" onClick={handleChange}>
			{headerNode}
		</Button>
	);

	return (
		<div
			className={classNames("more-details", {
				"more-details--has-icon": hasIcon,
			})}
			data-testid={dataTestid}
		>
			<Collapse onChange={handleChange} activeKey={activeKey}>
				<Panel
					header={
						<Button
							variant="borderless"
							{...(hasIcon && {
								startIcon: isExpanded ? expandedIcon : collapsedIcon,
							})}
						>
							{topHeaderNode}
						</Button>
					}
				>
					{children}
				</Panel>
			</Collapse>
			{bottomHeaderNode}
		</div>
	);
};

MoreDetails.propTypes = {
	expanded: PropTypes.bool,
	initialExpanded: PropTypes.bool,
	collapsedLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	expandedLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	headerPosition: PropTypes.oneOf(["top", "bottom"]),
	expandedIcon: PropTypes.element,
	collapsedIcon: PropTypes.element,
	onChange: PropTypes.func,
	"data-testid": PropTypes.string,
};

export default MoreDetails;
